export var PqlCaptureEventId;
(function (PqlCaptureEventId) {
    PqlCaptureEventId["SPOTTER_USER_MSG_RECEIVED"] = "spotter-user-msg-received";
    PqlCaptureEventId["SPOTTER_PIN_BUTTON"] = "spotter-pin-button";
    PqlCaptureEventId["SPOTTER_SAVE_BUTTON"] = "spotter-save-button";
    PqlCaptureEventId["SPOTTER_DOWNLOAD_BUTTON"] = "spotter-download-button";
    PqlCaptureEventId["NL_INSTRUCTIONS_BTN_CLICKED"] = "nl-instructions-btn-clicked";
    PqlCaptureEventId["SPOTTER_PREVIEW_DATA"] = "spotter-preview-data";
    PqlCaptureEventId["SPOTTER_AI_ANSWER_CONNECTOR_CONNECT"] = "spotter-ai-answer-connector-connect";
    PqlCaptureEventId["DRILL_DOWN"] = "drill-down";
    PqlCaptureEventId["EXPLORE_OPEN"] = "explore-open";
    PqlCaptureEventId["KPI_CHANGE_ANALYSIS_BUTTON_CLICK"] = "kpi-change-analysis-button-click";
    PqlCaptureEventId["HIGHLIGHTS_GENERATED"] = "highlights-generated";
    PqlCaptureEventId["MONITOR_ALERT_SAVE"] = "monitor-alert-save";
    PqlCaptureEventId["INVOKE_SPOTIQ_ANALYSIS"] = "invoke-spotiq-analysis";
    PqlCaptureEventId["CONNECT_TO_SLACK"] = "connect-to-slack";
    PqlCaptureEventId["STARTED_CONVERSATION_SPOTTER_VIZ"] = "started-conversation-spotter-viz";
    PqlCaptureEventId["QUERY_SENT_SPOTTER_VIZ"] = "query-sent-spotter-viz";
    PqlCaptureEventId["SAGE_BAR_QUERY_FIRED"] = "sage-bar-query-fired";
    PqlCaptureEventId["TOGGLE_LIVEBOARD_EDIT_SAVE"] = "toggle-liveboard-edit-save";
    PqlCaptureEventId["LIVEBOARD_STYLING_PROPERTY_CHANGED"] = "liveboard-styling-property-changed";
    PqlCaptureEventId["CSV_UPLOAD_SUCCESSFUL"] = "csv-upload-successful";
    PqlCaptureEventId["CSV_UPLOAD_ATTEMPT_FAILED"] = "csv-upload-attempt-failed";
    PqlCaptureEventId["EMBRACE_NEW_CONNECTION_CONFIRM"] = "embrace-new-connection-confirm";
    PqlCaptureEventId["DATA_CONNECTION_ATTEMPT_FAILED"] = "data-connection-attempt-failed";
    PqlCaptureEventId["GSHEETS_CONNECTION_ATTEMPT_FAILED"] = "gsheets-connection-attempt-failed";
    PqlCaptureEventId["DEVELOP_TAB_LOAD_PAGE"] = "develop-tab-load-page";
    PqlCaptureEventId["CREATE_PINBOARD"] = "create-pinboard";
    PqlCaptureEventId["ADD_VIZ_TO_EXISTING_PINBOARD"] = "add-viz-to-existing-pinboard";
    PqlCaptureEventId["ADD_VIZ_TO_NEW_PINBOARD"] = "add-viz-to-new-pinboard";
    PqlCaptureEventId["UPDATE_ANSWER"] = "update-answer";
    PqlCaptureEventId["CREATE_ANSWER"] = "create-answer";
    PqlCaptureEventId["FIRST_PIN_EXPERIENCE_BUTTON_CLICKED"] = "first-pin-experience-button-clicked";
    PqlCaptureEventId["MODEL_SAVE"] = "model-save";
    PqlCaptureEventId["MODEL_EDIT"] = "model-edit";
    PqlCaptureEventId["WORKSHEET_GENERATE_AI_SYNONYMS"] = "worksheet-generate-ai-synonyms";
    PqlCaptureEventId["AI_CONTEXT_GENERATION_BTN_CLICK"] = "ai-context-generation-btn-click";
    PqlCaptureEventId["NL_INSTRUCTIONS_SAVE_BTN_CLICKED"] = "nl-instructions-save-btn-clicked";
    PqlCaptureEventId["AI_QUERY_FEEDBACK_LOADED"] = "ai-query-feedback-loaded";
    PqlCaptureEventId["SPOTTER_CODE_RUN_CLICKED"] = "SpotterCode-run-clicked";
    PqlCaptureEventId["PLAYGROUND_RUN_CLICKED"] = "playground-run-clicked";
    PqlCaptureEventId["RUN_API_CLICKED"] = "Run-API-clicked";
    PqlCaptureEventId["GITHUB_RESOURCES_CLICKED"] = "Github-resources-clicked";
    PqlCaptureEventId["DISCORD_RESOURCES_CLICKED"] = "Discord-resources-clicked";
    PqlCaptureEventId["YOUTUBE_RESOURCES_CLICKED"] = "Youtube-resources-clicked";
    PqlCaptureEventId["GITHUB_HOMEPAGE_CLICKED"] = "Github-homepage-clicked";
    PqlCaptureEventId["DISCORD_HOMEPAGE_CLICKED"] = "Discord-homepage-clicked";
    PqlCaptureEventId["YOUTUBE_HOMEPAGE_CLICKED"] = "Youtube-homepage-clicked";
    PqlCaptureEventId["DEVELOPER_DOCS_HOMEPAGE_CLICKED"] = "Developer-docs-homepage-clicked";
    PqlCaptureEventId["SECURITY_SETTINGS_CLICKED"] = "Security-settings-clicked";
    PqlCaptureEventId["SHARE_OBJECT"] = "share-object";
    PqlCaptureEventId["INVITE_OTHERS"] = "invite-others";
    PqlCaptureEventId["CREATE_USER"] = "create-user";
    PqlCaptureEventId["TEAM_PRICING_PAGE"] = "team-pricing-page";
    PqlCaptureEventId["TEAM_PLAN_BUY_CTA"] = "team-plan-buy-cta";
    PqlCaptureEventId["TEAM_PLAN_CONTACT_SALES"] = "team-plan-contact-sales";
    PqlCaptureEventId["BOOK_1_1_CLICKED"] = "book-1-1-clicked";
    PqlCaptureEventId["INTERCOM_OPENED"] = "intercom-opened";
    PqlCaptureEventId["CHECKLIST_SECTION_COMPLETED"] = "checklist-section-completed";
})(PqlCaptureEventId || (PqlCaptureEventId = {}));
export var NudgeTargetCtaId;
(function (NudgeTargetCtaId) {
    NudgeTargetCtaId["VIEW_PRICE_BANNER_CLICKED"] = "view-price-banner-clicked";
    NudgeTargetCtaId["BOOK_1_1_BANNER_CLICKED"] = "book-1-1-banner-clicked";
})(NudgeTargetCtaId || (NudgeTargetCtaId = {}));
export var OnboardingEventId;
(function (OnboardingEventId) {
    OnboardingEventId["SPOTTER_CHAT_ASK_QUESTION"] = "spotter_chat.start_first_question";
    OnboardingEventId["SPOTTER_CHAT_PREVIEW_DATA"] = "spotter_chat.preview_data";
    OnboardingEventId["SPOTTER_CHAT_RESEARCH_MODE"] = "spotter_chat.deep_research_mode";
    OnboardingEventId["SPOTTER_CHAT_CONNECT_TOOLS"] = "spotter_chat.connect_tools";
    OnboardingEventId["SPOTTER_CHAT_V2_TOUR_FROM_PANEL"] = "spotter_chat_v2.tour_from_panel";
    OnboardingEventId["SPOTTER_CHAT_V2_FOLLOW_UP"] = "spotter_chat_v2.follow_up_question";
    OnboardingEventId["SPOTTER_CHAT_V2_VIEW_CAPABILITIES"] = "spotter_chat_v2.view_capabilities";
    OnboardingEventId["SPOTTER_CHAT_V2_CHAT_HISTORY"] = "spotter_chat_v2.chat_history";
    OnboardingEventId["SPOTTER_CHAT_V2_TOUR_CLOSED"] = "spotter_chat_v2.tour_closed";
    OnboardingEventId["TEAM_OF_AGENTS_DISCOVER_SPOTTER"] = "team_of_agents.discover_spotter";
    OnboardingEventId["TEAM_OF_AGENTS_DISCOVER_SPOTTERVIZ"] = "team_of_agents.discover_spotterviz";
    OnboardingEventId["TEAM_OF_AGENTS_DISCOVER_SPOTTERCODE"] = "team_of_agents.discover_spottercode";
    OnboardingEventId["SPOTTER_VIZ_BUILD_FIRST_DASHBOARD"] = "build_with_spotterviz.build_first_dashboard";
    OnboardingEventId["EXPLORE_DASHBOARDS_VIEW_DASHBOARD"] = "explore_dashboards.view_dashboard";
    OnboardingEventId["EXPLORE_DASHBOARDS_ANALYZE_METRIC_CHANGE"] = "explore_dashboards.analyze_metric_change";
    OnboardingEventId["EXPLORE_DASHBOARDS_DRILL_DOWN"] = "explore_dashboards.drill_down";
    OnboardingEventId["EXPLORE_DASHBOARDS_ASK_FOLLOWUP_QUESTION"] = "explore_dashboards.spotter_for_visualization";
    OnboardingEventId["EXPLORE_DASHBOARDS_TRACK_TOP_METRICS"] = "explore_dashboards.track_top_metrics";
    OnboardingEventId["EXPLORE_DASHBOARDS_FIND_YOUR_WAY"] = "explore_dashboards.find_your_way";
    OnboardingEventId["EXPLORE_INSIGHTS_VIEW_DASHBOARD"] = "explore_insights.view_dashboard";
    OnboardingEventId["EXPLORE_INSIGHTS_ASK_AI"] = "explore_insights.ask_ai";
    OnboardingEventId["EXPLORE_INSIGHTS_ANALYZE_METRIC_CHANGE"] = "explore_insights.analyze_metric_change";
    OnboardingEventId["EXPLORE_INSIGHTS_TRACK_METRICS"] = "explore_insights.track_metrics";
    OnboardingEventId["EXPLORE_INSIGHTS_USE_ENGAGE"] = "explore_insights.use_engage";
    OnboardingEventId["CREATE_INSIGHTS_CUSTOMIZE_DASHBOARD"] = "create_insights.customize_dashboard";
    OnboardingEventId["CREATE_INSIGHTS_REFINE_CHART"] = "create_insights.refine_chart";
    OnboardingEventId["CREATE_INSIGHTS_BUILD_VISUALIZATION"] = "create_insights.build_visualization";
    OnboardingEventId["CREATE_INSIGHTS_CONNECT_DATA"] = "create_insights.connect_data";
    OnboardingEventId["CREATE_INSIGHTS_TRAIN_AI"] = "create_insights.train_ai";
    OnboardingEventId["EMBED_INSIGHTS_LEARN_AND_BUILD"] = "embed_insights.learn_and_build";
    OnboardingEventId["EMBED_INSIGHTS_SETUP_SECURITY"] = "embed_insights.setup_security";
    OnboardingEventId["EMBED_WITH_SPOTTERCODE_EMBED_WITH_AGENT"] = "embed_with_spottercode.embed_with_agent";
    OnboardingEventId["EMBED_WITH_SPOTTERCODE_EXPLORE_DEVELOPER_PORTAL"] = "embed_with_spottercode.explore_developer_portal";
    OnboardingEventId["EMBED_WITH_SPOTTERCODE_V2_SPOTTERCODE_MCP"] = "embed_with_spottercode_v2.spottercode_mcp";
    OnboardingEventId["EMBED_WITH_SPOTTERCODE_V2_READ_DEVELOPER_DOCS"] = "embed_with_spottercode_v2.read_developer_docs";
    OnboardingEventId["EMBED_WITH_SPOTTERCODE_V2_TRY_REST_APIS"] = "embed_with_spottercode_v2.try_rest_apis";
    OnboardingEventId["TOUR_GUIDE_VISIBLE"] = "tour_guide_visible";
})(OnboardingEventId || (OnboardingEventId = {}));
//# sourceMappingURL=types.js.map